"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
const palette_1 = require("./palette");
exports.colors = {
    primary: palette_1.palette.darkBlue,
    main: palette_1.palette.red,
    secondary: palette_1.palette.darkGray,
    active: palette_1.palette.blue,
    hover: palette_1.palette.greenLight,
    white: palette_1.palette.white,
    black: palette_1.palette.black,
    green: palette_1.palette.green,
    darkGray: palette_1.palette.darkGray,
    gray: palette_1.palette.gray,
    darkBlue2: palette_1.palette.darkBlue2,
    neutral: palette_1.palette.neutral,
    neutral10: palette_1.palette.neutral10,
    neutral20: palette_1.palette.neutral20,
    neutral30: palette_1.palette.neutral30,
    danger100: palette_1.palette.danger100,
    danger20: palette_1.palette.danger20,
    tertiary: palette_1.palette.tertiary,
    secondaryGray: palette_1.palette.secondaryGray,
    secondaryGray2: palette_1.palette.secondaryGray2,
    secondaryLightGray: palette_1.palette.secondaryLightGray,
    secondaryLightGray2: palette_1.palette.secondaryLightGray2,
    textDisabled: palette_1.palette.textDisabled,
    text: {
        black: palette_1.palette.black,
        gray: palette_1.palette.darkGray,
        white: palette_1.palette.white,
        darkBlue: palette_1.palette.darkBlue,
        blue: palette_1.palette.blue,
        green: palette_1.palette.green,
        red: palette_1.palette.red,
    },
    system: {
        success: palette_1.palette.green,
        error: palette_1.palette.red,
        info: palette_1.palette.darkGray,
    },
    button: {
        background: {
            grayStandard: palette_1.palette.gray,
            darkStandard: palette_1.palette.darkGray,
            active: palette_1.palette.darkBlue,
            default: palette_1.palette.darkBlue,
            red: palette_1.palette.red,
        },
        color: {
            light: palette_1.palette.white,
            dark: palette_1.palette.darkBlue,
        },
    },
    input: {
        text: palette_1.palette.darkBlue,
        border: palette_1.palette.darkBlue,
    },
};
